import { ProgramAccess } from '@gql/generated';
import crypto from 'crypto';
import { isPast } from 'date-fns';
import cloneDeep from 'lodash/cloneDeep';
import { DISABLED_PROGRAMS } from './constants';

export const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const isMobile = function() {
  const agent = navigator.userAgent || navigator.vendor || window['opera'];
  if (/Mobile|iP(hone|od|ad)|Android/i.test(agent)) {
    return true;
  }
  return false;
};

export const generateUserKey = userId => {
  if (userId) {
    return crypto
      .createHmac('sha256', process.env.USE_NATIVE_API_SECRET)
      .update(userId)
      .digest('base64');
  }

  return null;
};

export function hexToRgbA(hex, alpha = 1) {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return (
      'rgba(' +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
      `,${alpha})`
    );
  }
  throw new Error('Bad Hex');
}

export const isParentElement = (parent: HTMLElement, child: HTMLElement) => {
  if (
    !child ||
    !parent ||
    child?.parentElement === null ||
    child?.parentElement instanceof HTMLBodyElement
  ) {
    return false;
  } else if (parent?.contains(child)) {
    return true;
  } else {
    return isParentElement(parent, child?.parentElement);
  }
};

export const findParentElement = (el: HTMLElement, selector) => {
  if (el) {
    if (el.parentElement?.matches(selector)) {
      return el.parentElement;
    }
    return findParentElement(el.parentElement, selector);
  }

  return null;
};

export const loadAddresses = address => {
  const config = {
    method: 'get',
    headers: {},
  };
  fetch(
    `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${address}&types=geocode&key=AIzaSyDTIqhUmW_Jx5E0CWOzIN6ZNNEtRqudfBo`,
    { ...config }
  );
};

export const normalizePrograms = items => {
  return cloneDeep(items).reduce((mergedList, item: ProgramAccess) => {
    if (item.program && DISABLED_PROGRAMS.includes(item.program.slug)) {
      // EXCLUDE DISABLED PROGRAMS
      return mergedList;
    } else if (item.program) {
      // HANDLE PROGRAMS
      if (item.program.lede && !item.program.shortDescription) {
        item.program.shortDescription = item.program.lede
          .replace(/<\/?[^>]+(>|$)/g, '')
          .replace(/(\r\n|\n|\r)/gm, '')
          .replace(/&nbsp;/gi, '');
      }
      const lang = item.program.language || 'se';
      if (item.program.slug === 'pausa-smart') {
        if (isPast(item.accessUntil)) {
          item.path = `/${lang}/pausasmart`;
        } else {
          item.path = `/${lang}/pausasmart/videos`;
        }
      } else if (item.program?.legacy) {
        item.path = `/${lang}/program/${item.program.slug}`;
      } else {
        item.path = `/${lang}/programs/${item.program.slug}/progress`;
      }
      item.progressPercentage = item.progressPercentage || 0;
    }

    mergedList.push(item);
    return mergedList;
  }, []);
};

export const isEnabledOnPage = (
  paths: Array<{ path: string; exact: boolean }>,
  pathname: string
) => {
  return paths.some(item => {
    if (item.exact) {
      return item.path === pathname;
    } else {
      return pathname.startsWith(item.path);
    }
  });
};

export const getCodeFromReturnUrl = to => {
  if (to) {
    let url = null,
      _to = to;

    // url params can also be array
    if (Array.isArray(_to)) {
      _to = (_to as string[])[0];
    }

    //
    if (String(_to).startsWith('/')) {
      // we only need domain for URL construction, doesnt matter which one
      const domain = process.env.DOMAIN || 'https://yogobe.com';

      url = new URL(domain + _to);
    } else if (String(_to).startsWith('http')) {
      url = new URL(_to);
    }

    if (url) {
      return (url as URL).searchParams.get('code');
    }
  }

  return null;
};
